var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".inner-close{fill:#fff;stroke:#fff;stroke-width:0.75px;fill-rule:evenodd;}")),React.createElement("path",{"className":"inner-close","d":"M15.53033,2.03033l-1.5-1.5-6,6-6-6-1.5,1.5,6,6-6,6,1.5,1.5,6-6,6,6,1.5-1.5-6-6Z","key":1})]);
}

MenuClose.defaultProps = {"viewBox":"0 0 16.06066 16.06066"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
